import React from "react";
import styles from "./Financial.module.css";


const cards = [
    {
        id: 1,
        content: (
            <>
                <p>Savings + Investments Review</p>
                <span>Evaluate how your savings align with your goals.</span>
            </>
        ),
    },
    {
        id: 2,

        content: (
            <>
                <p>Insurance Review</p>
                <span>Ensure your policies provide adequate coverage for you and your loved ones.</span>
            </>
        ),
    },
    {
        id: 3,

        content: (
            <>
                <p>Tax Planning</p>
                <span>Strategies for optimizing tax savings and tax returns.</span>
            </>
        ),
    },
    {
        id: 4,

        content: (
            <>
                <p>Loan Evaluation</p>
                <span>Insights to help reduce loan costs and strategies to pay down debts more efficiently.</span>
            </>

        ),
    },
];

const Financial = () => {
    return (
        <div className={styles.container}>
            <h1>What this Financial Review Includes</h1>
            <div className={styles.cardContainer}>
                {cards.map((card) => {
                    return (
                        <div key={card.id}>
                            <div> </div>
                            <div>{card.content}</div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default Financial;
